import { h } from 'preact'
import { FieldCommonProps } from '../../type'
import { RatingField as RatingFieldType } from 'scripts/type'
import RatingStar from '../Normal/RatingStar'
import { Description } from 'components/ui'

type Props = FieldCommonProps & {
  onSelect: (inputValue: number) => void
}

const Normal = (props: Props) => {
  const { field, onSelect } = props
  const { ratingMax, ratingMaxDescription, ratingMinDescription } = field as RatingFieldType
  const ratings = Array.from({ length: ratingMax }, (_, i) => i + 1)

  return (
    <div>
      <Description minDescription={ratingMinDescription} maxDescription={ratingMaxDescription} />
      <RatingStar ratings={ratings} onClick={onSelect} />
    </div>
  )
}

export default Normal
